export const CMS_DATA_BASE_URL =
  process.env.REACT_APP_DOMAIN || "https://aillia.hkdev.motherapp.com";
export const WEB_DOMAIN =
  process.env.REACT_APP_WEB_DOMAIN || 'https://web.aillia.motherapp.com';
export const DOWNLOAD_APP_DOMAIN =
  process.env.REACT_APP_DOWNLOAD_APP_DOMAIN ||
  'https://download.aillia.motherapp.cn';
export const CUSTOM_DEEP_LINK_SCHEMA = process.env.REACT_APP_CUSTOM_DEEP_LINK_SCHEMA || 'com.motherapp.aillia';
export const APP_NAME = process.env.REACT_APP_NAME || 'MA-Loyalty';
export const NO_LEVEL = process.env.REACT_APP_NO_LEVEL === 'true';
export const ONLY_HAVE_WEBSITE =
  process.env.REACT_APP_ONLY_HAVE_WEBSITE === 'true';
export const NO_SHOPIFY = process.env.REACT_APP_NO_SHOPIFY === 'true';
export const NO_WEB_APP = process.env.REACT_APP_NO_WEBAPP === 'true';
export const USE_RECAPTCHA = process.env.REACT_APP_USE_RECAPTCHA === 'true';
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const QRCODE_SHOW_RAW_MEMBERSHIP_ID =
  process.env.REACT_APP_QRCODE_SHOW_RAW_MEMBERSHIP_ID === 'true';
export const SHOPIFY_API_HOST =
  process.env.REACT_APP_SHOPIFY_API_HOST || 'https://ailliademo.myshopify.com';
export const NO_TRANSACTION_HISTORY = process.env.REACT_APP_NO_TRANSACTION_HISTORY === 'true';
export const SHOW_ONLINE_EMAIL_REMINDER = true;
export const MINIMUM_REGISTER_AGE = 0;
export const MAXIMUM_REGISTER_AGE = 150;

// support sign up method(s), have 3 options: "MOBILE_PHONE_NUMBER", "EMAIL_ADDRESS", "MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS"
export const PRIMARY_SIGN_UP_METHOD = "MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS";
// LOGIN_EDITABLE have 3 options: "EDITABLE", "CONTACT_CUSTOMER_SERVICE", "UNEDITABLE"
export const LOGIN_EDITABLE = "CONTACT_CUSTOMER_SERVICE";
// if PRIMARY_SIGN_UP_METHOD is MOBILE_PHONE_NUMBER or EMAIL_ADDRESS, LOGIN_OPTIONAL would not work
export const LOGIN_OPTIONAL = false;
// if PRIMARY_SIGN_UP_METHOD is MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS,
// SECOND_CONTACT_CONFIG, SECOND_CONTACT_EDITABLE and SECOND_CONTACT_HIDE_OTP would not work
// SECOND_CONTACT_CONFIG have 3 options: "DISABLE", "MANDATORY", "OPTIONAL"
export const SECOND_CONTACT_CONFIG = "OPTIONAL";
// SECOND_CONTACT_EDITABLE have 3 options: "EDITABLE", "CONTACT_CUSTOMER_SERVICE", "UNEDITABLE"
export const SECOND_CONTACT_EDITABLE = "EDITABLE";
export const SECOND_CONTACT_HIDE_OTP = false;

export const CONTACT_US_EMAIL = "Customercare@ka-pok.com";
export const CONTACT_US_PHONE = "+85266009429";
export const CONTACT_US_WHATSAPP_PHONE = "+85266009429";

// define if hide point to cash section
export const HIDE_POINT_TO_CASH_SECTION = false;

// open the website when click header logo
export const HEADER_LOGO_EXTRA_WEBSITE = process.env.HEADER_LOGO_EXTRA_WEBSITE || '';

// define if hide stamp rewards section
export const HIDE_STAMP_REWARDS_SECTION = false;

// the first is default language
export const SUPPORTED_LANGUAGE = ['en', 'zh-Hant'];

// define if hide reward claim section
export const HIDE_REWARD_CLAIM_SECTION = true;
export const SHOW_OPEN_APP_BANNER = true;
export const SHOW_NAVIGATOR = true;
export const SHOW_HOME_SIGNUP = true;
export const SHOW_BREADCRUMB = true;
export const ACTION_BUTTON_TO_COUPON_PAGE = true;
export const SHOW_SHARE_BUTTON = true;
export const SHOW_FOOTER = true;

// wechat
export const WE_CHAT_OFFICIAL_ACCOUNT_APP_ID = process.env.REACT_APP_WE_CHAT_OFFICIAL_ACCOUNT_APP_ID || '';

export const MAINTENANCE_CONFIG = process.env.REACT_APP_MAINTENANCE_CONFIG || '';
